import Vue from 'vue'
import axios from 'axios'

const state = {
  limit: 20,
  isFetching: false,
  isFetchingNoti: false,
  isUpdating: false,
  professionals: null,
  hasCompletedOrders: false,
  userData: null,
  verifiedSmsStatus: null,
  notifications: [],
  notificationDropdown: [],
  isError: false,
  userVerification: null,
  skipAddingLine: false,
  canLoadMore: false,
  remainingServiceHours: 0,
  totalBookings: 0
}

const actions = {
  LOAD_NOTIFICATION_ACTIVITY: async ({ commit, rootState }, queryData) => {
    let currentLang = rootState.globalVal.currentLanguage
    queryData.dropdown_menu ? commit('SET_IS_FETCHING_NOTI', true) : commit('SET_IS_FETCHING', true)
    // let { data } = await axios.get(`users-activities?user_id=${rootState.auth.user.id}?lang=${currentLang}`)
    let { data } = await axios.get('users-activities', {
      params: {
        user_id: rootState.auth.user.id,
        lang: currentLang,
        ...queryData
      }
    })
    if (!data.error) {
      if (queryData.dropdown_menu) {
        commit('SET_NOTIFICATION_DROPDOWN_LIST', data.user_activities)
      } else {
        commit('SET_NOTIFICATIONS', data.user_activities)
      }
    }
    commit('SET_ERROR', data.error)
    queryData.dropdown_menu ? commit('SET_IS_FETCHING_NOTI', false) : commit('SET_IS_FETCHING', false)
  },
  LOAD_USER_PROFILE: ({ commit }, userId) => {
    const url = 'users/' + userId
    Vue.http.get(url)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          const userData = {
            firstName: response.first_name,
            lastName: response.last_name,
            tel: response.tel,
            picture: response.picture
          }
          commit('SET_USER_DATA', userData)
        }
      })
  },
  LOAD_PROFESSIONAL_LIST: async ({ commit }, queryData) => {
    if (queryData.page === 0) {
      commit('SET_PROFESSIONALS', null)
    }
    const url = `users/${queryData.user_id}/professionals`
    const { data } = await axios.get(url, { params: queryData })
    if (!data.error) {
      (queryData.page > 0) ? commit('ADD_PROFESSIONAL_LIST', data.professionals) : commit('SET_PROFESSIONAL_LIST', data.professionals)
      const canLoadMore = (data.professionals.length >= data.limit)
      commit('SET_CAN_LOAD_MORE', canLoadMore)
    } else {
      commit('SET_NO_DATA')
      if (queryData.page === 0) {
        commit('SET_PROFESSIONALS', [])
      }
    }
  },
  HAS_COMPLETED_ORDERS: ({ commit }, userId) => {
    const url = 'users/' + userId + '/has-completed-orders'
    Vue.http.get(url)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_HAS_COMPLETED_ORDERS', true)
        } else {
          commit('SET_HAS_COMPLETED_ORDERS', false)
        }
      })
  },
  ADD_USER_EXPERIENCE: async ({ commit }, submitData) => {
    const url = `users/${submitData.user_id}/experience`
    await axios.post(url, submitData)
      .catch(err => {
        console.log('error:', err)
      })
  },
  DELETE_USER_EXPERIENCE: async ({ commit }, submitData) => {
    const url = `users/${submitData.user_id}/experience`
    await axios.delete(url, { data: submitData })
      .catch(err => {
        console.log('error:', err)
      })
  },
  ADD_FAVORITE_PROFESSIONAL: ({ commit }, submitData) => {
    const url = 'users/' + submitData.user_id + '/favorites'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          console.log(response)
        }
      })
  },
  DELETE_FAVORITE_PROFESSIONAL: ({ commit }, submitData) => {
    const url = 'users/' + submitData.user_id + '/favorites'
    Vue.http.delete(url, { body: submitData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          console.log(response)
        }
      })
  },
  LOAD_USER_VERIFICATION: async ({ commit }, userId) => {
    const url = `users/${userId}/verification`
    commit('SET_USER_VERIFICATION', null)
    let { data } = await axios.get(url)
    if (!data.error) {
      commit('SET_USER_VERIFICATION', data)
    }
  },
  saveUserProfile: async ({ commit }, submitData) => {
    commit('SET_IS_UPDATING', true)
    const url = `users/${submitData.user_id}`
    const res = await axios.put(url, submitData)
    commit('SET_IS_UPDATING', false)
    if (res.status === 200) {
      const response = res.data
      console.log(response)
    }
  },
  fetchRemainingServiceHours: async ({ commit }, userId) => {
    const url = `users/${userId}/remaining-service-hours`
    const { data } = await axios.get(url)
    if (!data.error) {
      commit('SET_USER_REMAINING_SERVICE_HOURS', {
        remaininServiceHours: Number(data.remaining_service_hours),
        totalBookings: Number(data.total_bookings)
      })
    }
  }
}

const mutations = {
  SET_CAN_LOAD_MORE: (state, status) => {
    state.canLoadMore = status
  },
  SET_NOTIFICATION_DROPDOWN_LIST: (state, data) => {
    if (data.length > 0) {
      state.notificationDropdown.push(...data)
    } else {
      state.notificationDropdown = data
    }
  },
  SET_IS_FETCHING_NOTI: (state, data) => {
    state.isFetchingNoti = data
  },
  SET_ERROR: (state, data) => {
    state.isError = data
  },
  SET_NOTIFICATIONS: (state, data) => {
    if (data.length > 0) {
      state.notifications.push(...data)
    } else {
      state.notifications = data
    }
  },
  SET_IS_FETCHING: (state, status) => {
    state.isFetching = status
  },
  ADD_PROFESSIONAL_LIST: (state, professionals) => {
    state.isFetching = false
    state.isMore = true
    for (let key in professionals) {
      state.professionals.push(professionals[key])
    }
    if (professionals.length < state.limit) {
      state.isMore = false
    }
  },
  SET_PROFESSIONAL_LIST: (state, professionals) => {
    state.isFetching = false
    state.isMore = true
    state.professionals = professionals
    if (professionals.length < state.limit) {
      state.isMore = false
    }
  },
  SET_PROFESSIONALS: (state, data) => {
    state.professionals = data
  },
  SET_HAS_COMPLETED_ORDERS: (state, status) => {
    state.hasCompletedOrders = status
  },
  SET_USER_DATA: (state, userData) => {
    state.userData = userData
  },
  SET_IS_UPDATING: (state, status) => {
    state.isUpdating = status
  },
  SET_NO_DATA: (state) => {
    state.isMore = false
    state.professionals = null
  },
  SET_USER_VERIFICATION: (state, data) => {
    state.userVerification = data
  },
  SET_SKIP_ADDING_LINE: (state, status) => {
    state.skipAddingLine = status
  },
  UPDATE_PROFESSIONAL_DATA: (state, data) => {
    if (state.professionals && state.professionals.length > 0) {
      state.professionals[data.index][data.key] = data.value
    }
  },
  SET_USER_REMAINING_SERVICE_HOURS: (state, data) => {
    state.remainingServiceHours = data.remainingServiceHours
    state.totalBookings = data.totalBookings
  }
}

const getters = {
  getState: state => {
    return state
  },
  getProfessionals: state => {
    return state.professionals
  },
  getHasCompletedOrders: state => {
    return state.hasCompletedOrders
  },
  getUserData: state => {
    return state.userData
  },
  getIsUpdating: state => {
    return state.isUpdating ? 'message.button.loading' : 'message.button.save'
  },
  isLoadMore: state => {
    return state.isFetching ? 'message.button.loading' : 'message.button.load_more'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js